import React, { createContext, useState, useEffect } from "react";
import translations from "../i18n/lang";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");

  // Initialize with English as default - clear any previous language preference
  useEffect(() => {
    localStorage.setItem("app_lang", "en");
  }, []);

  useEffect(() => {
    localStorage.setItem("app_lang", lang);
  }, [lang]);

  const t = (key) => {
    return translations[lang] && translations[lang][key]
      ? translations[lang][key]
      : key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
